enum KycStepType {

    PersonalInfo = "PersonalInfo",
    Address = "Address",
    FinancialDetails = "FinancialDetails",
    TradingExperience = "TradingExperience",
    TopUp = "TopUp",
    TradingProfile = "TradingProfile",
    FinancialDetailsInternational = "FinancialDetailsInternational",
    IdentityVerification = "IdentityVerification",
    StartTrading = "StartTrading",
}

namespace KycStepType {

    export function deserialize(id: number): KycStepType {
        if (id) {
            switch (id) {
                case 1:
                    return KycStepType.PersonalInfo;
                case 2:
                    return KycStepType.Address;
                case 3:
                    return KycStepType.TopUp;
                case 4:
                    return KycStepType.FinancialDetailsInternational;
                case 5:
                    return KycStepType.IdentityVerification;
                case 6:
                    return KycStepType.StartTrading;
            }
        }
        return null;
    }
}

export {
    KycStepType
}
